// it has to be called messages...https://github.com/kazupon/vue-i18n/issues/244
const sc = {
  message: {
    choose_date_time: "选择日期及时间",
    choose_tickets: "选择门票 | 选择门票 | 选择 {count} 张门票",
    ticket_delivery: "邮寄地址",
    empty_basket: "你未选购任何项目",
    shopping_cart: "购物篮",
    choose_seating_area: "请选择座位分区",
    newsletter_signup:
      "本人同意订阅《西九艺讯》电子通讯<br><br>我们有意使用阁下提供的个人资料提供给你西九文化区的活动及节目资讯。若你同意有关使用，请在上面空格内划上剔号。你可随时根据「<a href='https://www.westk.hk/sc/privacy#pics' target='_blank'>收集个人资料声明</a>」取消订阅，或查阅或改正你的个人资料。",
    choose_seats: "请于{sectionAlias}选择座位",
    budget_per_ticket: "票价",
    ticket_quantity_header: "门票数量",
    ticket_quantity_body: "您想买多少张门票？",
    best_available_body: "我们建议的两组座位已用蓝色标示，请选择并按「确定座位」继续。",
    hot_show_body: "我们推荐给您的座位以黄色突出显示。请按「确定座位」继续。",
    calendar_prompt: "请从标示的日子中，",
    calendar_instruction: "选取你想要的日期和时间。",
    confirmation_screen: "购票确认",
    register_success: "感谢阁下登记是次活动",
    register_confirmation_email: "我们将发电邮至阁下的电子邮箱以兹确认",
    booking_reference: "交易编号",
    download_eticket: "下载你的电子门票",
    privacy_policy:
      "提交此表格代表我已详细阅读及完全明白并同意受「<a href='https://www.westk.hk/sc/termsandconditions' target='_blank'>条款及细则</a>」之约束，以及同意局方可根据「<a href='https://www.westk.hk/sc/privacy' target='_blank'>私隐政策</a>」使用于本表格上提供的个人资料。",
    payment_method: "付款方式",
    booking_date: "交易日期",
    help: "帮助",
  },
  payment: {
    payment_details: "请选择付款方式",
    payment_failed: "付款失败",
    payment_failed_explanation: "交易失败。我们无法处理您的付款。请重新尝试。",
    order_confirmation: "订单已确认！感谢你的订购。确认电邮已发送至{email}",
    order_summary: "订单摘要",
    subtotal: "小计",
    delivery_cost: "郵費",
    total: "总计",
    donate_link: "支持西九文化区",
    customer_portal: "请查阅「我的活动」检视已购买的订单。",
    pdf_link: "下载你的电子门票",
    continue_shopping: "继续选购",
    quantity: "数量",
    unit_price: "票价",
    booking_fee: "手续费",
    ticket_details: "详情",
    no_cost: "你购物篮内的项目无须收费，请按「继续」以完成订购。",
  },
  payment_methods: {
    JCB_WKCD_ONLINE: "JCB",
    CUP_WKCD_ONLINE: "银联卡在线支付",
    AMEX_WKCD_ONLINE: "美国运通",
    VISA_WKCD_ONLINE: "Visa",
    MASTER_WKCD_ONLINE: "Mastercard",
  },
  newsletter: {
    button: "订阅",
    placeholder: "您的电子邮件地址",
  },
  announcement: {
    title: "通知",
    null_str: "暂时没有通知",
    view_all: "查看所有",
  },
  availability: {
    sold_out: "售罄",
    available: "可选",
    limited_seats: "座位有限",
    single_seat: "单人座位",
  },
  event: {
    status: {
      available: "门票",
      limited: "尚余少量",
      sold_out: "售罄",
      cancelled: "节目取消",
      postponed: "节目延期",
      coming_soon: "即将发售",
      temporarily_off_sale: "暂时停售",
    },
  },
  session: {
    status: {
      coming_soon: "即将接受报名",
      registration_closed: "已截止登记",
      full: "名额已满",
      full_extended: "本活动没有足够报名名额。",
      temporarily_unavailable: "暂时未能提供",
    },
  },
  register: {
    register_title: "报名表格",
    register_description: "已注册MyWestKowloon帐户？立即登入，让登记活动更快捷方便。",
    newsletter:
      "本人选择不接收西九文化区电子通讯 ，包括但不限于有关会员礼遇、商店／商品推广及活动邀请的最新消息。<br><br>局方拟根据\"<a href='https://www.westk.hk/sc/about-us/privacy' target='_blank'>私隐政策</a>\"，于局方內部及与特选合作伙伴共享使用阁下的个人资料，发送与产品、活动、节目及服务有关的推广讯息。",
    submit: "立即报名",
    select_session_title: "选择日期及时间",
    not_this_user: "不是 {name} 吗？",
    registration_complete: "继续浏览节目及活动",
    registration_sign_up_prompt: " 注册帐户",
    help_text: "必填项目",
  },
  ticket: {
    add_ticket: "增加 1 张门票",
    remove_ticket: "减少 1 张门票",
    discount_code: "请输入推广优惠密码。",
    quantity: "数量",
    price: "票价",
    type: "门票种类",
    failed_to_add_to_cart: "无法加入购物篮",
    successfully_added_to_cart: "成功加入购物篮",
  },
  timer: {
    timer_text_1: "预订座位只保留",
    timer_text_2: "分钟",
  },
  buttons: {
    seat_area_and_tickets: "下一步",
    view_calendar: "查看日曆",
    add_to_basket: "加入购物篮",
    payment_method: "下一步",
    return_to_website: "返回网页",
    checkout: "确认订购",
    save_basket_and_continue: "继续购买",
    ok_continue: "确定",
    go_back: "返回",
    close: "关闭",
    choose_seats: "下一步",
    confirm_seats: "下一步",
    ok_got_it: "确定",
    hide_calendar: "隐藏日曆",
    zoom_in: "放大",
    zoom_out: "缩小",
    zoom_reset: "重设",
    add_link_text: "购买更多门票",
    ok: "确定",
    back: "返回",
  },
  footer: {
    copyright: "WestK及WestK标志均为西九文化区管理局的商标。",
    copyright_2: " 西九文化区管理局。保留所有权利。",
    links: {
      privacy: "私隐政策",
      ts_and_cs: "条款及细则",
      freedom_of_information: "网站资讯",
      contact: "联络我们",
      join_in: "关注我们",
    },
  },
  modal: {
    cart_timer_warning: "你的选购时间尚馀5分钟",
    cart_timer_body: "你的购物篮将於5分钟後自动清空。如阁下未能於限定时间内完成交易，已选门票将会被取消。",
    ticket_advisory_title: "告示",
    choose_area: {
      availability: "座位供应情况",
      category: "票价",
      section: "分区",
    },
    accessible_zone: {
      title: "无障碍区",
      message:
        "你刚选择的座位在无障碍区，仅供轮椅使用者及其陪同者使用。我们保留拒绝非合资格人士进场或调动其座位的权利。如确定，即代表你已明白你所选的座位对象，及选购的门票供轮椅使用者及其陪同者使用。",
    },
    members_only: {
      title: "你已选取会员门票",
      no_valid_membership: "所选择的门票种类只适用于特定的会籍类别，请选择其他门票种类。",
      quota_reached: "你选择的会员门票超出你可兑换的数量，请修改或选择其他门票种类。",
      connection_issue: "无法连接会员系统，请稍后再试。",
      further_information: "查看更多",
      select_non_member_tickets: "拣选非会员门票",
    },
    hkid_warning_header: "阁下须持有人香港身份证以享有折扣优惠。",
    hkid_warning_body: "在入场前，阁下或须出示有效之香港身份证。",
    delete_confirm_title: "你确定想移除此项目？",
    delete_confirm_text: "确定移除此项目后，你可能无法再次选取相同的项目。",
  },
  account: {
    overview: "概览",
    events: "我的活动",
    profile: "我的帐户",
    logout: "登出",
    hello: "你好",
    sign_in: "登入",
    new_customer: "新用户?",
    start_here: "马上註册",
    your_account: "你的帐户",
    login: "登入",
    shoppingCart: "购物篮",
    myEvent: "我的活动",
  },
  errors: {
    select_all_tickets: "门票种类的数量须与已选座位的数量相同，请选择 {count} 张门票",
    max_allowed_tickets: "您不能选择多于({count}) 张门票。",
    invalid_discount_code_format: "请输入正确的推广优惠码。",
    fix_errors: "非常抱歉，购票过程出现错误，请稍候并重新尝试。如问题持续，请致电票务热线（852）2200 0022。",
    no_seating_area_selected: "非常抱歉，购票过程出现错误，请稍候并重新尝试。如问题持续，请致电票务热线（852）2200 0022。",
    seating_area_failed: "非常抱歉，购票过程出现错误，请稍候并重新尝试。如问题持续，请致电票务热线（852）2200 0022。",
    retrieve_seat_options: "非常抱歉，购票过程出现错误，请稍候并重新尝试。如问题持续，请致电票务热线（852）2200 0022。",
    date_times_retrieval_failed: "非常抱歉，购票过程出现错误，请稍候并重新尝试。如问题持续，请致电票务热线（852）2200 0022。",
    ticket_type_retrieval_failed: "非常抱歉，购票过程出现错误，请稍候并重新尝试。如问题持续，请致电票务热线（852）2200 0022。",
    delivery_method_retrieval_failed: "非常抱歉，购票过程出现错误，请稍候并重新尝试。如问题持续，请致电票务热线（852）2200 0022。",
    shopping_cart_submission_failed: "系统出现错误，请稍后再试。(加入购物篮失败)",
    shopping_cart_items_retrieval_failed: "非常抱歉，购票过程出现错误，请稍候并重新尝试。如问题持续，请致电票务热线（852）2200 0022。",
    select_a_set: "请选择座位",
    too_many_tickets: "你最多只能选择40个座位。",
    reserve_tickets_failed: "系统出现错误，请稍後再试。（无法预留座位）",
    required_field: "* 必填项目",
    some_tickets_werent_added: "非常抱歉，购票过程出现错误，请稍候并重新尝试。如问题持续，请致电票务热线（852）2200 0022。",
    cart_confirmation: "非常抱歉，购票过程出现错误，请稍候并重新尝试。如问题持续，请致电票务热线（852）2200 0022。",
    seat_offers_failed_other: "非常抱歉，购票过程出现错误，请稍候并重新尝试。如问题持续，请致电票务热线（852）2200 0022。",
    ticket_type_available_quantity: "所选择的数量不正确。",
    registration_submission_failed: "无法完成登记，请稍后再试。",
    registration_generic_error: "非常抱歉，购票过程出现错误，请稍候并重新尝试。如问题持续，请致电票务热线（852）2200 0022。",
    generic_error: "非常抱歉，购票过程出现错误，请稍候并重新尝试。如问题持续，请致电票务热线（852）2200 0022。",
    invalid_email: "请输入有效的电邮",
    crm: {
      sip: {
        error: {
          "401001": "非常抱歉，购票过程出现错误，请稍候并重新尝试。如问题持续，请致电票务热线（852）2200 0022。",
          "401002": "非常抱歉，购票过程出现错误，请稍候并重新尝试。如问题持续，请致电票务热线（852）2200 0022。",
          "401003": "非常抱歉，购票过程出现错误，请稍候并重新尝试。如问题持续，请致电票务热线（852）2200 0022。",
          "404001": "非常抱歉，购票过程出现错误，请稍候并重新尝试。如问题持续，请致电票务热线（852）2200 0022。",
          "405001": "非常抱歉，购票过程出现错误，请稍候并重新尝试。如问题持续，请致电票务热线（852）2200 0022。",
          "500100": "非常抱歉，购票过程出现错误，请稍候并重新尝试。如问题持续，请致电票务热线（852）2200 0022。",
          "400001": "非常抱歉，购票过程出现错误，请稍候并重新尝试。如问题持续，请致电票务热线（852）2200 0022。",
          "400500": "非常抱歉，购票过程出现错误，请稍候并重新尝试。如问题持续，请致电票务热线（852）2200 0022。",
          "500001": "非常抱歉，购票过程出现错误，请稍候并重新尝试。如问题持续，请致电票务热线（852）2200 0022。",
          "500200": "非常抱歉，购票过程出现错误，请稍候并重新尝试。如问题持续，请致电票务热线（852）2200 0022。",
          "500201": "非常抱歉，购票过程出现错误，请稍候并重新尝试。如问题持续，请致电票务热线（852）2200 0022。",
          "410001": "非常抱歉，购票过程出现错误，请稍候并重新尝试。如问题持续，请致电票务热线（852）2200 0022。",
          "400701": "非常抱歉，购票过程出现错误，请稍候并重新尝试。如问题持续，请致电票务热线（852）2200 0022。",
        },
        "no-vacancy": "本活动没有足够报名名额。",
      },
    },
    sistic: {
      error: {
        cart: {
          "add-event": {
            "mix-not-allowed": "无法新增项目至购物篮，请先完成购买已放入购物篮的项目。",
          },
          "add-to-cart": {
            fail: "系统出现错误，请稍后再试。(加入购物篮失败)",
            product: {
              "no-config": "系统出现错误，请稍后再试。(没有设定)",
            },
            "quota-reached": "系统出现错误，请稍后再试。(超过活动门票最大数量)",
          },
          barcode: {
            retrieval: {
              fail: "系统出现错误，请稍后再试。(条码定义和条码字段)",
            },
          },
          "exceed-allocation": "系统出现错误，请稍后再试。(超出购物篮的节目数量上限)",
          "exceed-max-qty": "所选的门票种类超过限购数量。",
          inventory: {
            check: {
              fail: "系统出现错误，请稍后再试。(计算库存时出错)",
            },
            duplicates: "系统出现错误，请稍后再试。(在购物篮中找到重复项目)",
            empty: "系统出现错误，请稍后再试。(库存清单是空的)",
            "groupbooking-ga": {
              "not-found": "",
            },
            "quantity-price-class": {
              mismatch: "系统出现错误，请稍后再试。(库存和价格的数量不符)",
            },
          },
          "new-event": {
            "mix-not-allowed": "无法新增项目至购物篮，请先完成购买已放入购物篮的项目。",
          },
          "not-found": "系统出现错误，请稍后再试。(没有找到购物篮)",
          order: {
            "cart-total-amount": {
              mismatch: "系统出现错误，请稍后再试。(购物篮项目总金额不符)",
            },
            "delivery-charge": {
              mismatch: "系统出现错误，请稍后再试。(运费不符)",
            },
            generic: "系统出现错误，请稍后再试。(无法处理您的订单)",
            "not-found-expired": "系统出现错误，请稍后再试。(订单参考编号尚未找到或过期)",
            "paid-amount": {
              mismatch: "系统出现错误，请稍后再试。(订单参考编号支付金额不符)",
            },
            "product-total-amount": {
              mismatch: "系统出现错误，请稍后再试。(产品总量不符)",
            },
            seat: {
              "not-available": "系统出现错误，请稍后再试。(座位无法使用)",
              reserve: {
                fail: "系统出现错误，请稍后再试。(未能预留座位)",
              },
            },
          },
          postcommit: {
            "calculated-precommit-amount": {
              mismatch: "系统出现错误，请稍后再试。(总金额不符)",
            },
            "exceed-quota": "购物篮内的项目超过限购数量。",
            fail: "系统出现错误，请稍后再试。(无法确认订单)",
            inventory: {
              unavailable: "系统出现错误，请稍后再试。(座位可能未能确认)",
            },
          },
          precommit: {
            "creditcard-delivery-method": {
              invalid: "此信用卡不适用于所选的领取方法。",
            },
            "creditcard-price-class": {
              invalid: "此信用卡不适用于所选的门票种类。",
            },
            "delivery-method": {
              invalid: "系统出现错误，请稍后再试。(领取方法无效)",
              "no-fee-config": "系统出现错误，请稍后再试。(领取方法尚未设定收费)",
            },
            "mailing-address": {
              invalid: "系统出现错误，请稍後再试。 (邮寄国家/地区无效)",
            },
            "payment-method": {
              creditcard: {
                invalid: "此信用卡不适用于所选的付款方式。",
              },
              invalid: "无法完成交易。请使用其他付款方式。",
            },
            "product-offsales": "系统出现错误，请稍后再试。(暂时停止销售)",
          },
          promo: {
            code: {
              "hold-code": {
                "no-config": "推广优惠代码无效。",
              },
              invalid: "推广优惠代码无效。",
              popup: {
                text: "推广优惠代码无效。",
              },
              "price-class": {
                mismatch: "系统出现错误，请稍后再试。(未与推广优惠代码绑定)",
              },
            },
            password: {
              empty: "必须输入推广优惠密码。",
              inactive: "系统出现错误，请稍后再试。(推广优惠密码未启用)",
              incorrect: "推广优惠密码错误。",
              invalid: "推广优惠密码无效。",
              "quota-reached": "推广优惠密码超过使用上限。",
            },
          },
          "qty-config": {
            qty: {
              mismatch: "所选择的数量不正确。",
            },
          },
          "sales-quota": {
            transaction: {
              exceeded: "订单无法处理。你所选购的门票现已沽清，请重新选择其他门票种类 。为你造成不便，我们深感抱歉。",
            },
          },
          "top-status": {
            payment: {
              fail: {
                firstdata: "交易失败。我们无法处理您的付款。请重新尝试。",
              },
            },
          },
        },
        product: {
          "detail-seatmap": {
            generation: {
              coordinate: {
                missing: "系统出现错误，请稍后再试。(座位图内容 - 坐标)",
              },
              fail: "系统出现错误，请稍后再试。(座位图细节错误)",
              seatangle: {
                missing: "系统出现错误，请稍后再试。(座位图内容 - 座位角度)",
              },
            },
            insufficient: "系统出现错误，请稍后再试。(座位不足)",
          },
          icc: {
            invalid: "对不起，此活动已结束。有关西九的最新活动资讯，请浏览本网站「<a href='https://www.westk.hk/sc/whats-on/' target='_blank'>节目及活动</a>」。",
            "not-found": "对不起，此活动已结束。有关西九的最新活动资讯，请浏览本网站「<a href='https://www.westk.hk/sc/whats-on/' target='_blank'>节目及活动</a>」。",
          },
          "no-common-delivery": "系统出现错误，请稍后再试。(没有找到常用的领取方法)",
          "no-common-delivery-payment": "系统出现错误，请稍后再试。(没有找到常用的领取方法和付款方式)",
          "no-common-payment": "系统出现错误，请稍后再试。(没有找到常用的付款方式)",
          "overview-seatmap": {
            generation: {
              fail: "系统出现错误，请稍后再试。(产生概览座位图)",
            },
          },
          param: {
            icc: {
              missing: "系统出现错误，请稍后再试。(遗失的互联网内容码)",
            },
            mode: {
              missing: "系统出现错误，请稍后再试。(遗失的活动模式)",
            },
            "price-cat-id": {
              missing: "系统出现错误，请稍后再试。(遗失的价格类别ID)",
            },
            "product-id": {
              missing: "系统出现错误，请稍后再试。(遗失的产品ID)",
            },
            quantity: {
              missing: "系统出现错误，请稍后再试。(数量不足)",
            },
            "seat-section-id": {
              missing: "系统出现错误，请稍后再试。(遗失的座段ID)",
            },
          },
          seats: {
            release: "系统出现错误，请稍后再试。(释放座位时出错)",
            reserve: "系统出现错误，请稍后再试。(预订座位时出错)",
          },
          "updated-event": {
            "not-found": "系统出现错误，请稍后再试。(未找到活动更新)",
          },
        },
      },
    },
  },
  language: {
    selected: "请选择语言。现时设定为簡体中文。",
  },
  delivery_details: {
    delivery_address_1: "地址第一行",
    delivery_address_2: "地址第二行",
    delivery_address_3: "地址第三行",
    postcode: "邮政编码",
    select_a_country: "请选择国家 / 地区",
  },
  delivery_warning: {
    hong_kong_only: "香港特别行政区",
    macau_only: "澳门特别行政区",
  },
  delivery_methods: {
    KIOSK_OFFICE_PICKUP_WKCD: {
      title: "亲临场地票务处或自助售票机领取门票",
      description: "顾客需携带交易时使用之信用卡、交易编号及电邮地址，亲临场地售票处或自助售票机领取门票。请注意个别节目之特别要求。",
    },
    COURIER_HK: {
      title: "速递（香港）",
      description: "送递门票时，收件人须签收确认",
    },
    COURIER_MC: {
      title: "速递（澳门）",
      description: "送递门票时，收件人须签收确认",
    },
    COURIER_ML1: {
      title: "速递（中国内地）",
      description: "送递门票时，收件人须签收确认",
    },
    COURIER_OS1: {
      title: "速递（海外）",
      description: "门票配送上门时（香港、澳门、中国内地除外）时，须收件人签收作实。",
    },
    E_TICKET: {
      title: "电子门票",
      description: "系统将发送确认电邮至您所提供的电邮地址，并附上PDF电子门票。届时请点击电邮上的链接，下载电子门票。",
    },
    REGISTERED_MAIL_HK: {
      title: "挂号（香港）",
      description: "送递门票时，收件人须签收确认。",
    },
    REGISTERED_MAIL_OS: {
      title: "挂号（海外）",
      description: "送递门票时，收件人须签收确认。",
    },
    BLANK_DELIVERY_OPTION: {
      title: "请选择领取门票方式",
    },
  },
  seats_legend: {
    available: "可选",
    unavailable: "不可选",
    selected: "已选",
    offered: "座位提供",
  },
  seating_selection_info: {
    your_selection: "你选择了",
    row: "行",
    seat: "座位",
    selected: "",
  },
  search: {
    placeholder: "站内搜寻...",
    cta: "搜寻",
  },
  header: {
    logged_in: {
      text: "登出後你在購物籃裡的項目將會被移除。",
    },
  },
};

export default sc;
